module.exports = __webpack_public_path__ + "assets/drop-marker.19373e838249f247d26146bde1e1e5d5.png";